// actions.js
import {
  FETCH_COMMENTS_REQUEST,
  FETCH_COMMENTS_SUCCESS,
  FETCH_COMMENTS_FAILURE,
  DELETE_COMMENTS_REQUEST,
  DELETE_COMMENTS_FAILURE,
  DELETE_COMMENTS_SUCCESS,
  FETCH_COMMENT_REQUEST,
  FETCH_COMMENT_SUCCESS,
  FETCH_COMMENT_FAILURE,
  UPDATE_COMMENTS_REQUEST,
  UPDATE_COMMENTS_SUCCESS,
  UPDATE_COMMENTS_FAILURE,
  CLEAR_COMMENT_ERRORS,
  CLEAR_COMMENT_SUCCESS,
} from './actionTypes';

export const fetchCommentsRequest = () => ({
  type: FETCH_COMMENTS_REQUEST,
});

export const fetchCommentsSuccess = (comments) => ({
  type: FETCH_COMMENTS_SUCCESS,
  payload: comments,
});

export const fetchCommentsFailure = (error) => ({
  type: FETCH_COMMENTS_FAILURE,
  payload: error,
});

export const fetchCommentRequest = (id) => ({
  type: FETCH_COMMENT_REQUEST,
  payload: id
});

export const fetchCommentSuccess = (comment) => ({
  type: FETCH_COMMENT_SUCCESS,
  payload: comment,
});

export const fetchCommentFailure = (error) => ({
  type: FETCH_COMMENT_FAILURE,
  payload: error,
});

export const updateCommentRequest = (comment, navigate) => ({
  type: UPDATE_COMMENTS_REQUEST,
  payload: { comment, navigate }
});

export const updateCommentSuccess = () => ({
  type: UPDATE_COMMENTS_SUCCESS,
});

export const updateCommentFailure = (error) => ({
  type: UPDATE_COMMENTS_FAILURE,
  payload: error,
});

export const deleteCommentRequest = (id) => ({
  type: DELETE_COMMENTS_REQUEST,
  payload: id
});

export const deleteCommentSuccess = (id) => ({
  type: DELETE_COMMENTS_SUCCESS,
  payload: id,
});

export const deleteCommentFailure = (error) => ({
  type: DELETE_COMMENTS_FAILURE,
  payload: error,
});

export const clearCommentErrors = () => ({
  type: CLEAR_COMMENT_ERRORS,
});

export const clearCommentSuccess = () => ({
  type: CLEAR_COMMENT_SUCCESS,
});